export default __webpack_public_path__ + "static/media/new-ideas_wide.6d52635c.png";